// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../../utils/CSS.bs.js";
import * as Unicons$Showside from "../../icons/Unicons.bs.js";
import * as Category$Showside from "../../types/Category.bs.js";
import * as NavMenu__Context$Showside from "./NavMenu__Context.bs.js";
import * as EntrypointContext$Showside from "../../context/EntrypointContext.bs.js";
import * as ConfigurationProvider$Showside from "../../context/ConfigurationProvider.bs.js";
function useLinkFromCategory(labelFormatOpt, category) {
  var labelFormat = labelFormatOpt !== undefined ? labelFormatOpt : [/* GenericCTA */0, /* ProductCount */2];
  var match = ConfigurationProvider$Showside.use(undefined);
  var match$1 = match.config.settings;
  var openLinkInNewTab = match$1.openLinkInNewTab;
  var openLinkLabel = match$1.openLinkLabel;
  var match$2 = Belt_Option.flatMap(category, Category$Showside.ExternalConnection.getStoreCategoryConnection);
  var count;
  if (match$2 !== undefined) {
    var count$1 = match$2.count;
    count = count$1 > 0 ? "(" + count$1.toString() + ")" : undefined;
  } else {
    count = undefined;
  }
  var label = Belt_Array.keepMap(Belt_Array.map(labelFormat, function (part) {
    switch (part) {
      case /* GenericCTA */0:
        return openLinkLabel;
      case /* CategoryTitle */1:
        return Belt_Option.map(category, function (category) {
          return category.title;
        });
      case /* ProductCount */2:
        return count;
    }
  }), function (a) {
    return a;
  }).join(" ");
  return React.useMemo(function () {
    if (category !== undefined) {
      return Belt_Option.flatMap(Category$Showside.Link.getCardFallbackLink(category), function (link) {
        if (link.TAG === /* URL */0) {
          return {
            href: link._0,
            label: label,
            openInNewTab: openLinkInNewTab,
            category: category
          };
        }
      });
    }
  }, [Belt_Option.map(category, function (category) {
    return category.lastModifiedAt;
  })]);
}
function NavMenu__Link(Props) {
  var link = Props.link;
  var classNameOpt = Props.className;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var match = EntrypointContext$Showside.use(undefined);
  var trackEvent = match.trackEvent;
  var ctx = NavMenu__Context$Showside.use(undefined);
  var handleClick = function (e) {
    Curry.app(trackEvent, ["menu:link clicked", true, link.category, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
  };
  var match$1 = ctx.mode;
  var tmp = {
    className: Cn.make([className, CSS$Showside.prefix("inline-flex relative text-secondary no-underline hover:underline"), match$1 ? CSS$Showside.prefix("text-base whitespace-nowrap px-2 py-1") : CSS$Showside.prefix("text-lg")]),
    href: link.href,
    onClick: handleClick
  };
  var tmp$1 = link.openInNewTab ? "_blank" : undefined;
  if (tmp$1 !== undefined) {
    tmp.target = Caml_option.valFromOption(tmp$1);
  }
  return React.createElement("a", tmp, React.createElement("div", undefined, link.label), React.createElement("div", {
    className: CSS$Showside.prefix("ml-1 -mr-1 flex items-center")
  }, React.createElement(Unicons$Showside.UilAngleRightB.make, {
    size: /* Px */{
      _0: 16
    }
  })));
}
NavMenu__Link.displayName = "NavMenu__Link";
var make = NavMenu__Link;
export { useLinkFromCategory, make };
/* react Not a pure module */